var MD5 = require('md5.js')

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}



//////////////////
// WEBPACK FOOTER
// ./~/_create-hash@1.2.0@create-hash/md5.js
// module id = 287
// module chunks = 0